import { useFilterValue } from '@btime/react-contexts'
import React from 'react'

import { useFilterValueText } from '../../../../utils/helpers/filters'
import ChecklistsFilterSideModal from '../../../../containers/checklists/filters/ChecklistsFilterSideModal'
import FilterLink from '../../../../components/filter/FilterLink'
import FilterListItem from '../../../../components/list/FilterListItem'

const options = [
  { label: 'Error', value: 'error' },
  { label: 'Warn', value: 'warn' },
  { label: 'Info', value: 'info' },
  { label: 'Debug', value: 'debug' },
  { label: 'Monitor', value: 'monitor' },
  { label: 'Trigger', value: 'trigger' }
]

const LevelsFilter = ({ field, label, icon, presentation, ...props }) => {
  const [open, setOpen] = React.useState(false)

  presentation = presentation || 'bar'
  label = label || 'Level'
  field = field || 'levels'
  const value = useFilterValue(field, [])

  const selectedValue = useFilterValueText(field)
  const Link = presentation === 'bar' ? FilterLink : FilterListItem

  return (
    <>
      <Link
        icon={presentation === 'bar' && (icon || 'RiPriceTag3Line')}
        label={label}
        value={selectedValue}
        onClick={() => setOpen(true)}
      />

      <ChecklistsFilterSideModal
        open={open}
        onClose={() => setOpen(false)}
        label={label}
        field={field}
        options={options}
        useLoader={false}
        {...props}
      />
    </>
  )
}

export default LevelsFilter
